import { type FunctionComponent, Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { NewCommentProps } from './NewComment';

export const LazyNewComment: FunctionComponent<NewCommentProps> = (props) => {
  const NewComment = useLazyComponent(
    () => import(/* webpackChunkName: "new-comment" */ './NewComment'),
    { namedImport: 'NewComment' },
  );

  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-web-eng', feature: 'Comments' }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <NewComment {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
